import React, { useEffect, useState } from 'react';
import { MessageCircle, Send, ExternalLink } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { buildWhatsAppUrl, applyTemplate, numeroWhatsAppProspecto } from '../utils/constants';
import { valorDe } from './CamposPropios';

export default function WhatsAppModal({ lead, onClose }) {
  /* Un prospecto puede traer su primer mensaje ya escrito por Prospección: arranca
     con ese y se puede editar igual. Si no tiene, todo sigue como siempre. */
  const esProspecto = lead.source === 'prospeccion';
  const mensajePropio = esProspecto ? String(valorDe(lead, 'mensaje_whatsapp') || '') : '';
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [message, setMessage] = useState('');
  const [countryCode, setCountryCode] = useState('54');

  useEffect(() => {
    api.get('/templates').then(res => {
      setTemplates(res.data);
      const defaultTpl = res.data.find(t => t.is_default) || res.data[0];
      if (mensajePropio) setMessage(mensajePropio);
      else if (defaultTpl) {
        setSelectedTemplate(defaultTpl);
        setMessage(applyTemplate(defaultTpl.message, lead));
      }
    });
    api.get('/settings').then(res => {
      if (res.data.default_country_code) setCountryCode(res.data.default_country_code);
    });
  }, [lead, mensajePropio]);

  const selectTemplate = (tpl) => {
    setSelectedTemplate(tpl);
    setMessage(applyTemplate(tpl.message, lead));
  };

  const send = async () => {
    const url = esProspecto
      ? `https://wa.me/${numeroWhatsAppProspecto(lead, { whatsapp: valorDe(lead, 'whatsapp') })}?text=${encodeURIComponent(message || '')}`
      : buildWhatsAppUrl(lead.phone, message, countryCode);
    window.open(url, '_blank');
    try {
      await api.post(`/leads/${lead.id}/contact`, {
        template_id: selectedTemplate?.id,
        message_sent: message
      });
      toast.success('Contacto registrado');
    } catch (err) { console.error(err); }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <MessageCircle size={22} color="#22c55e" />
          <h2 style={{ margin: 0 }}>Contactar por WhatsApp</h2>
        </div>

        <div style={{ background: 'var(--bg-secondary)', padding: 14, borderRadius: 10, marginBottom: 16 }}>
          <div style={{ fontWeight: 600 }}>{lead.business_name}</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
            {lead.phone}{esProspecto && <> · se abre como +{numeroWhatsAppProspecto(lead, { whatsapp: valorDe(lead, 'whatsapp') })}</>}
          </div>
        </div>

        <div className="form-group">
          <label>Plantilla</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {templates.map(tpl => (
              <button key={tpl.id} className={`btn btn-sm ${selectedTemplate?.id === tpl.id ? 'btn-primary' : 'btn-secondary'}`}
                onClick={() => selectTemplate(tpl)}>
                {tpl.name}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>Mensaje (podés editarlo)</label>
          <textarea value={message} onChange={e => setMessage(e.target.value)}
            rows={4} style={{ resize: 'vertical' }} />
        </div>

        <div style={{ background: 'var(--bg-secondary)', padding: 14, borderRadius: 10, marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>PREVIEW</div>
          <div style={{ fontSize: 14, color: 'var(--text-primary)', whiteSpace: 'pre-wrap' }}>{message}</div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn" onClick={send}
            style={{ background: '#22c55e', color: '#fff', borderRadius: 50 }}>
            <ExternalLink size={14} /> Abrir WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}
